import './freeShippingAlert.scss';

import { useMemo } from 'react';

import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { IDeliveryDiscountData } from '@/store/ducks/deliveryDiscount/types';
import { IProduct } from '@/store/ducks/products/types';

interface Props {
  product?: IProduct;
  delivery_discount_data?: IDeliveryDiscountData | null;
  type?: 'card' | 'product';
}

function FreeShippingAlert({ product, delivery_discount_data }: Props) {
  const { configs } = useWebContext();
  const textColor = useTextColor(configs.free_shipping_tag_color);

  const hasFreeShipping = useMemo(() => {
    if (delivery_discount_data) {
      return delivery_discount_data.type_discount === 'free';
    }
    return product?.full_products.some((fp) => fp.delivery_discount_data?.type_discount === 'free');
  }, [product?.full_products]);

  return (
    <>
      {hasFreeShipping && (
        <div
          className="free-shipping-alert"
          style={{
            backgroundColor: configs.free_shipping_tag_color,
            color: textColor,
          }}
        >
          <span className="buy-and-win">Compre e ganhe</span>
          <span className="free-shipping">FRETE GRÁTIS</span>
        </div>
      )}
    </>
  );
}

export default FreeShippingAlert;
